import { COLORS } from "@/common/constants";
import { MenuIconProps } from "./IconPropTypes";

const DashboardMenu = ({ isActive, style }: MenuIconProps) => {
    const color = isActive ? COLORS.MENU.ACTIVE : COLORS.MENU.INACTIVE;
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
            <path d="M4 4H10V12H4V4Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 16H10V20H4V16Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 12H20V20H14V12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 4H20V8H14V4Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default DashboardMenu;
